import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserDetailsBankAccount } from 'components/User'
import { UserProtectedRoute } from 'routes'

const UserBankAccountPage: FC = () => {
  const navigate = useNavigate()

  return (
    <UserProtectedRoute>
      <UserDetailsBankAccount onBack={() => navigate(-1)} />
    </UserProtectedRoute>
  )
}

export default UserBankAccountPage
